var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 108,
    height: 108,
    rx: 10,
    fill: "#CF375D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2501 83.2501H60.7501V87.7501H47.2501V83.2501ZM45.0001 76.5001H63.0001V81.0001H45.0001V76.5001ZM69.9498 26.8158C65.7212 22.5816 60.0568 20.2501 54.0001 20.2501C51.0433 20.243 48.1144 20.8202 45.3814 21.9484C42.6483 23.0767 40.1652 24.7337 38.0744 26.8244C35.9837 28.9152 34.3267 31.3983 33.1984 34.1314C32.0702 36.8644 31.493 39.7933 31.5001 42.7501C31.5001 49.306 34.013 55.4387 38.3907 59.5744L39.0038 60.1496C41.5365 62.5177 45.0001 65.7619 45.0001 68.6251V74.2501H51.7501V55.8437L45.5232 52.3126L48.0938 48.6169L54.0001 51.7501L59.8065 48.6015L62.4924 52.2127L56.2501 55.869V74.2501H63.0001V68.6251C63.0001 65.8294 66.4257 62.588 68.9274 60.2199L69.6179 59.5646C74.1207 55.2657 76.5001 49.4452 76.5001 42.7501C76.515 39.7931 75.9438 36.8624 74.8195 34.1275C73.6952 31.3925 72.04 28.9074 69.9498 26.8158Z",
    fill: "#ECB32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationIcon);
export default __webpack_public_path__ + "static/media/innovation-icon.058da78e5facfe548de8833167830da6.svg";
export { ForwardRef as ReactComponent };